import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { TokenDecode } from '../../../utils/general-util';

import {
  listPowerSearchFilter,
  createPowerSearchFilter,
  updatePowerSearchFilter,
  deletePowerSearchFilter,
} from '../../../utils/powerSearch-utils';

export const getTokenDecode = createAsyncThunk('getTokenDecode', async () => {
  const response = await TokenDecode();
  return response;
});

export const listPowerSearchFilterReq = createAsyncThunk('listPowerSearchFilterReq', async (obj) => {
  const response = await listPowerSearchFilter(obj);
  return response;
});

export const createPowerSearchFilterReq = createAsyncThunk('createPowerSearchFilterReq', async (obj) => {
  const response = await createPowerSearchFilter(obj);
  return response;
});

export const updatePowerSearchFilterReq = createAsyncThunk('updatePowerSearchFilterReq', async (obj) => {
  const response = await updatePowerSearchFilter(obj);
  return response;
});

export const deletePowerSearchFilterReq = createAsyncThunk('deletePowerSearchFilterReq', async (obj) => {
  const response = await deletePowerSearchFilter(obj);
  return response;
});

const PowerSearchSlice = createSlice({
  name: 'powersearch',
  initialState: {
    listFilter: [],
    deleteFilter: [],
    createFilter: [],
    updateFilter: [],
    getTokenDecode: [],
  },
  reducers: {
    handleDeleteFilterLocally: {
      reducer() {
        // state.listFilter = action.payload.listFilter;
      },
      prepare(listFilter) {
        return {
          payload: { listFilter },
        };
      },
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTokenDecode.fulfilled, (state, action) => {
        state.getTokenDecode = action.payload !== undefined ? action.payload : [];
      })
      .addCase(listPowerSearchFilterReq.fulfilled, (state, action) => {
        state.listFilter = action.payload ? action.payload : [];
      })
      .addCase(deletePowerSearchFilterReq.fulfilled, (state, action) => {
        state.deleteFilter = action.payload ? action.payload : [];
      })
      .addCase(createPowerSearchFilterReq.fulfilled, (state, action) => {
        state.createFilter = action.payload ? action.payload : [];
      })
      .addCase(updatePowerSearchFilterReq.fulfilled, (state, action) => {
        state.updateFilter = action.payload ? action.payload : [];
      });
  },
});

export const { handleDeleteFilterLocally } = PowerSearchSlice.actions;

export default PowerSearchSlice.reducer;
